import {BaseServiceClass} from "../../../base-service-class";
import httpClient, {ApiResponseWrapper} from "../../../http-client";
import {GetHistoryWithFilterRequest, HistoryModel} from "./models";


export default class PoleHistoryApi extends BaseServiceClass {
    static getPoleHistory(args: GetHistoryWithFilterRequest, token: string) {
        return httpClient.post<ApiResponseWrapper<HistoryModel[]>>(this.PATH_REPORT.poleHistory, args, {
            headers: {
                Authorization: `Bearer ${token}`
            },
        }).then((res) => res.data);
    }
}